import httpClient from '@/http-client'
export const get = (Options = {}) => {
    return httpClient
        .get('/api/credit-transfers', Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const store = data => {
    return httpClient
        .post('/api/credit-transfers', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const getSubject = (Options = {}) => {
    return httpClient
        .get('/api/credit-transfers/get-subjects', Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const deleteItem = id => {
    return httpClient
        .post(`/api/credit-transfers/remove/${id}`)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const printPdf = id => {
    return httpClient
        .get(`/api/credit-transfers/print-pdf/${id}`)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const attachFile = data => {
    return httpClient
        .post('/api/credit-transfers/attachement-files', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
    return httpClient
        .get(`/api/credit-transfers/${id}`, Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const uploadfile = data => {
    return httpClient
        .post('/api/credit-transfers/upload-logo', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const religion = (Options = {}) => {
  return httpClient
    .get('/api/student-profiles/religions')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const nationality = (Options = {}) => {
  return httpClient
    .get('/api/student-profiles/nationalities')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const itemList = (Options = {}) => {
  return httpClient
    .get('/api/credit-transfers/item-lists')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const uploadPhoto = data => {
  return httpClient
    .post('/api/credit-transfers/upload-photoes', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const storeStudentProfile = data => {
  return httpClient
    .post('/api/credit-transfers/store-student-profiles', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
    store,
    getSubject,
    get,
    deleteItem,
    printPdf,
    attachFile,
    find,
    uploadfile,
    nationality,
    religion,
    itemList,
    uploadPhoto,
    storeStudentProfile
}